import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import ChatConversationView, {
  ChatConversationViewProps,
} from "./ChatConversationView";
import { useTranslation } from "react-i18next";
type ChatConversationModalProps = {
  open: boolean;
  setOpen: (Status: boolean) => void;
} & ChatConversationViewProps;

export default function ChatConversationModal(
  props: ChatConversationModalProps
) {
  const {
    open,
    setOpen,
    messageGroups,
    onMessageChange,
    onSendDraftMessage,
    draftMessage,
    isLoadingMessages,
    messageBoxInputRef,
  } = props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10 block  md:hidden"
        onClose={setOpen}
      >
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full ">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => setOpen(false)}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-6 ">
                      {" "}
                      <div className="flex-grow relative px-1 ">
                        <ChatConversationView
                          messageGroups={messageGroups}
                          isLoadingMessages={isLoadingMessages}
                          onMessageChange={onMessageChange}
                          onSendDraftMessage={onSendDraftMessage}
                          messageBoxInputRef={messageBoxInputRef}
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
